// extracted by mini-css-extract-plugin
module.exports = {"carousel":"styles_carousel__1_Ay9","carouselItem":"styles_carouselItem__2Q-KV","carouselCaption":"styles_carouselCaption__3x_gZ","carouselImage":"styles_carouselImage__1hIEv"};